import React from 'react';

const cardRow = { display: 'flex', flexWrap: 'wrap' };
const cardsStyle = { padding: '0 10px', margin: 'auto' };
const cardItemStyle = { margin: '0' };
const labelStyle = {
  color: '#777',
  fontSize: '14px',
  textTransform: 'uppercase',
  letterSpacing: '1px',
};

const getHtnBioResponseCards = (systolic, diastolic, isLoading, isLast) => {
  systolic = systolic ? systolic.toFixed(2) : 0;
  diastolic = diastolic ? diastolic.toFixed(2) : 0;

  return (
    <>
      <div className="col-md-3" style={cardsStyle}>
        <div className="well" style={cardItemStyle}>
          <p style={labelStyle}>Average {isLast ? 'of last' : ''} Systolic</p>
          <h1>{isLoading ? 'Loading..' : systolic}</h1>
        </div>
      </div>
      <div className="col-md-3" style={cardsStyle}>
        <div className="well" style={cardItemStyle}>
          <p style={labelStyle}>Average {isLast ? 'of last' : ''} Diastolic</p>
          <h1>{isLoading ? 'Loading..' : diastolic}</h1>
        </div>
      </div>
    </>
  );
};

const AverageResponseCards = ({
  averageBio,
  patientCount,
  patientInControlPercent,
  averageByOffice,
  isLast,
  isLoading,
  category,
}) => {
  patientCount = patientCount ? patientCount : 0;
  patientInControlPercent = patientInControlPercent ? (patientInControlPercent * 100).toFixed(2) : 0;

  return (
    <>
      <div className="row" style={cardRow}>
        {category.toLowerCase() === 'htn' &&
          getHtnBioResponseCards(averageBio?.systolic, averageBio?.diastolic, isLoading, isLast)}
        <div className="col-md-3" style={cardsStyle}>
          <div className="well" style={cardItemStyle}>
            <p style={labelStyle}>Number of unique patients</p>
            <h1>{isLoading ? 'Loading..' : patientCount}</h1>
          </div>
        </div>
        <div className="col-md-3" style={cardsStyle}>
          <div className="well" style={cardItemStyle}>
            <p style={labelStyle}>Percentage of patients under control</p>
            <h1>{isLoading ? 'Loading..' : patientInControlPercent}%</h1>
          </div>
        </div>
      </div>
      {averageByOffice && Object.keys(averageByOffice).length > 1 && (
        <div style={{ paddingTop: '20px' }}>
          <table class="table average-table">
            <tr>
              <th>App Code</th>
              {Object.keys(averageBio).map((item) => (
                <th>
                  Average of {isLast ? 'of last' : ''} {item}
                </th>
              ))}
              <th>Number of unique patients</th>
              <th>Percentage of patients under control</th>
            </tr>
            {Object.keys(averageByOffice).map((item) => (
              <tr>
                <td>{item}</td>
                {Object.keys(averageByOffice[item].average_bio).map((avg) => (
                  <td>{averageByOffice[item].average_bio[avg].toFixed(2)}</td>
                ))}
                <td>{averageByOffice[item].patientCount}</td>
                <td>{(averageByOffice[item].patientInControlPercent * 100).toFixed(2)}%</td>
              </tr>
            ))}
          </table>
        </div>
      )}
    </>
  );
};

export default AverageResponseCards;
